import React from "react";
import { Link } from "react-router-dom";
import imgHospital from '../../../assets/images/p1.png'
import imgMoney from '../../../assets/images/p2.png'
import imgTelecom from '../../../assets/images/p3.png'
import imgIbfolio from '../../../assets/images/p4.png'

const ProjectHome = () => {

    return (
        <div className="projects">
            <div>
                <div className="projects-sticky">
                    <h1 className="project-title">Nos réalisations</h1>
                    <p>
                    Nous avons construit une équipe solide capable de fournir la meilleure qualité de services dans la conception de sites Web, le développement de sites Web, le développement de jeux...
                    </p>
                </div>
                
            </div>
            <div className="grid2">
                <div className="projects-wrap">
                    <div className="projects-description">
                        <span className="projects-category">E-service</span>
                        <h2 className="projects-title2">Gestion de transfert d'argent (Orange money)</h2>
                        <Link to='' className="projects-link">Voir projet</Link>
                    </div>
                    <div className="projects-wrapping-img">
                        <img src={imgMoney} alt="" />
                    </div>
                </div>
                <div className="projects-wrap projects-trans">
                    <div className="projects-description">
                        <span className="projects-category">E-service</span>
                        <h2 className="projects-title2">L'application santé pour CSCOM</h2>
                        <Link to='' className="projects-link">Voir projet</Link>
                    </div>
                    <div className="projects-wrapping-img">
                        <img src={imgHospital} alt="" />
                    </div>
                </div>
                <div className="projects-wrap">
                    <div className="projects-description">
                        <span className="projects-category">Infrastrucure</span>
                        <h2 className="projects-title2">Le Projet 2020, Installation DBS (Orange, MoovAfrica)</h2>
                        <Link to='' className="projects-link">Voir projet</Link>
                    </div>
                    <div className="projects-wrapping-img">
                        <img src={imgTelecom} alt="" />
                    </div>
                </div>
                <div className="projects-wrap projects-trans">
                    <div className="projects-description">
                        <span className="projects-category">E-service</span>
                        <h2 className="projects-title2">Mon Portolio</h2>
                        <Link to='' className="projects-link">Voir projet</Link>
                    </div>
                    <div className="projects-wrapping-img">
                        <img src={imgIbfolio} alt="" />
                    </div>
                </div>

            </div>
            
        </div>
    )
}

export default ProjectHome